/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */

export enum LocalStorageKey {
  EDITOR_PREFERENCES = 'hedgedoc-editor-preferences',
  DARK_MODE = 'hedgedoc-darkmode',
  MOTD_LAST_MODIFIED = 'hedgedoc-motd-last-modified',
  GUEST_UUID = 'hedgedoc-guest-uuid',
  DEBUG_LOGGING = 'hedgedoc-debug-logging',
  CUSTOM_DELAY = 'hedgedoc-custom-delay',
  LANGUAGE = 'hedgedoc-language'
}
